import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import cryptoHoldingsService from "@cryptoHoldingsService";

export function useFetchCryptoHoldings() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['crypto_holdings', user?.id],
    queryFn: async () => {
      return await cryptoHoldingsService.getCryptoHoldings();
    },
    enabled: !!user,
  });
}

export function useCreateCryptoHolding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CryptoHoldingCreateRequest) => {
      return await cryptoHoldingsService.createCryptoHolding(request);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['crypto_holdings'] });
      qc.invalidateQueries({ queryKey: ['crypto_wallets'] });
    },
  });
}

export function useUpdateCryptoHolding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request : CryptoHoldingUpdateRequest) => {
      return await cryptoHoldingsService.updateCryptoHolding(request);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['crypto_holdings'] }),
  });
}

export function useDeleteCryptoHolding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await cryptoHoldingsService.deleteCryptoHolding(id);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['crypto_holdings'] }),
  });
}
